import { useEffect } from "react";

import { MeterFieldProps } from "../../../types/salesDocuments.types";
import { useMeterContext } from "../meterContext";
import { suppliers } from "../salesDocuments.constants";

export const SupplierComponent: React.FC<MeterFieldProps> = ({ meter, hidden }) => {
  const ctx = useMeterContext();
  const availableProducts =
    suppliers
      .find((s) => s.value === ctx.supplier)
      ?.products.filter((p) => p.allowedFuels.includes(meter.fuelType)) ?? [];

  useEffect(() => {
    ctx.handleSupplierChange(ctx.supplier);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- seed the default product once on mount; ctx changes every render
  }, []);

  if (hidden) return null;

  return (
    <div className="sales-doc-field mb-3">
      {/* Select supplier dropdown */}
      <hr className="sales-doc-divider" />
      <label htmlFor={`meter-${meter.id.toString()}-supplier-select`}>Supplier</label>
      <select
        id={`meter-${meter.id.toString()}-supplier-select`}
        className="form-control"
        value={ctx.supplier}
        onChange={(e) => {
          ctx.handleSupplierChange(e.target.value);
        }}
      >
        {suppliers.map((s) => (
          <option key={s.value} value={s.value}>
            {s.label}
          </option>
        ))}
      </select>
      {/* Other supplier allows free entry */}
      {ctx.supplier === "other" && (
        <div className="sales-doc-field mb-3">
          <label htmlFor={`meter-${meter.id.toString()}-supplier-name-entry`}>Supplier Name</label>
          <input
            className="form-control"
            type="text"
            id={`meter-${meter.id.toString()}-supplier-name-entry`}
            value={ctx.supplierName}
            onChange={(e) => {
              ctx.setSupplierName(e.target.value);
            }}
            required
          />
        </div>
      )}
      {/* Any suppliers with zero products gets free entry (including other) */}
      <label htmlFor={`meter-${meter.id.toString()}-product-select`}>Product Name</label>
      {availableProducts.length ? (
        <select
          className="form-control"
          id={`meter-${meter.id.toString()}-product-select`}
          value={ctx.product}
          onChange={(e) => {
            ctx.handleProductChange(e.target.value);
          }}
        >
          {availableProducts.map((p) => (
            <option key={p.id} value={p.id}>
              {p.productName}
            </option>
          ))}
        </select>
      ) : (
        <input
          type="text"
          id={`meter-${meter.id.toString()}-product-free-entry`}
          className="form-control"
          value={ctx.product}
          onChange={(e) => {
            ctx.handleProductChange(e.target.value);
          }}
        />
      )}
    </div>
  );
};
